import { useEffect, useState } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import Sidebar, { SidebarContent } from "@/app/Sidebar";
import TopBar from "@/app/TopBar";
import VerifyBanner from "@/app/VerifyBanner";
import MobileTabBar from "@/app/MobileTabBar";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { api } from "@/lib/api";

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [org, setOrg] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let active = true;
    api.get("/organizations/me")
      .then(({ data }) => { if (active) setOrg(data.organization); })
      .catch(() => {})
      .finally(() => { if (active) setLoaded(true); });
    return () => { active = false; };
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  if (!loaded) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="app-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-primary" />
      </div>
    );
  }

  if (org && !org.onboarded) {
    return <Navigate to="/app/onboarding" replace />;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-muted/20">
      <Sidebar />

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-72 border-border bg-card p-0">
          <SidebarContent onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar onOpenMobile={() => setMobileOpen(true)} org={org} />
        <VerifyBanner />
        <main className="flex-1 overflow-y-auto pb-20 lg:pb-0" data-testid="app-main">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 sm:py-8">
            <Outlet context={{ org, setOrg }} />
          </div>
        </main>
      </div>
      <MobileTabBar />
    </div>
  );
}
